import type { ErrorResponse } from '@eika-infrastruktur/request';
import type {
    ApproveCreateShareSavingsAccountForChildProcessPayload,
    CreateShareSavingsAccountForChildProcess,
} from '@generated-types';
import { approveProcess } from '@react-query/services/process';
import { useMutation } from '@tanstack/react-query';

export const useApproveProcess = () => {
    return useMutation<
        CreateShareSavingsAccountForChildProcess,
        ErrorResponse,
        ApproveCreateShareSavingsAccountForChildProcessPayload
    >({
        mutationKey: ['process'],
        mutationFn: (payload) => approveProcess(payload),
    });
};
